const mapPrismicImageProxy = (url: string) => {
    if (!url) {
        return url;
    }

    return url
        .replace(
            'https://images.prismic.io/',
            'https://prismic-cache-images.paypo.pl/',
        )
        .replace(
            'https://www-paypo-pl.cdn.prismic.io/',
            'https://prismic-cache-cdn.paypo.pl/',
        );
};

export default mapPrismicImageProxy;
